import * as React from "react";
import { SVGProps } from "react";
const SvgChat = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25 5c2.2 0 4 1.8 4 4v11c0 2.2-1.8 4-4 4h-3v5a1 1 0 0 1-1.602.799L12.7 24H7c-2.2 0-4-1.8-4-4V9c0-2.2 1.8-4 4-4h18Zm0 2H7c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h6c.2 0 .4.1.6.2L20 27v-4a1 1 0 0 1 1-1h4c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChat;
